import React, { ReactNode, useState } from "react";
import PulseLoader from "react-spinners/PulseLoader";

function SubtleButton({
  onClick,
  disabled = false,
  loading = false,
  loaderColor = "#fffafa",
  loaderSize = 5,
  label,
  children,
  className,
  testId,
  type = "button",
  buttonRole = "default",
  title,
}: {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  loading?: boolean;
  loaderColor?: string;
  loaderSize?: number;
  label?: string;
  children?: ReactNode;
  className?: string;
  testId?: string;
  type?: "button" | "submit" | "reset";
  buttonRole?: string;
  title?: string;
}) {
  let roleCSS =
    "bg-full-white hover:bg-slate-50 text-full-black border-[#cccccc]";
  if (buttonRole === "primary") {
    roleCSS =
      "bg-snow-blue-3 hover:bg-sky-700 text-full-white border-snow-blue-3";
  }
  if (buttonRole === "danger") {
    roleCSS = "bg-full-white hover:bg-slate-50 text-snow-red border-snow-red";
  }
  const [loadingInternal, setloadingInternal] = useState<boolean>(false);
  return (
    <button
      onClick={async (e) => {
        if (!loading && !loadingInternal && typeof onClick === "function") {
          setloadingInternal(true);
          try {
            await onClick(e);
          } finally {
            setloadingInternal(false);
          }
        }
      }}
      disabled={disabled || loading || loadingInternal}
      className={`border rounded-md p-2 text-sm shadow-sm font-semibold ${roleCSS} ${disabled ? "cursor-not-allowed opacity-40" : ""} ${className ?? ""}`}
      data-testid={testId ?? null}
      type={type}
      title={title}
    >
      {loading || loadingInternal ? (
        <PulseLoader
          color={loaderColor}
          size={loaderSize}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ) : (
        label ?? children
      )}
    </button>
  );
}

export default SubtleButton;
